// NAVIG8 Performance Budgets — Web Vitals observer
// Thresholds aligned with Google "good" targets.

import { trackEvent } from "./tracking";

const BUDGETS = {
  LCP: 2500,  // ms — Largest Contentful Paint
  FID: 100,   // ms — First Input Delay
  CLS: 0.1,   //     — Cumulative Layout Shift (unitless)
  FCP: 1800,  // ms — First Contentful Paint
  TTFB: 800,  // ms — Time to First Byte
};

function ratingFor(name, value) {
  const budget = BUDGETS[name];
  if (budget == null) return "unknown";
  if (name === "CLS") {
    if (value <= 0.1) return "good";
    if (value <= 0.25) return "needs-improvement";
    return "poor";
  }
  if (value <= budget) return "good";
  if (value <= budget * 1.5) return "needs-improvement";
  return "poor";
}

/**
 * Callback compatible with reportWebVitals().
 * Logs to console in dev; sends GA4 custom events in production.
 */
export function handleWebVital(metric) {
  const { name, value, id, rating } = metric;
  const grade = rating || ratingFor(name, value);
  const budget = BUDGETS[name];
  const overBudget = budget != null && name !== "CLS" ? value > budget : value > (budget ?? Infinity);

  if (process.env.NODE_ENV === "development") {
    const style = overBudget ? "color:#e74c3c;font-weight:bold" : "color:#2ecc71";
    // eslint-disable-next-line no-console
    console.log(
      `%c[WebVital] ${name}: ${name === "CLS" ? value.toFixed(3) : Math.round(value)}ms  (${grade})`,
      style
    );
    return;
  }

  trackEvent("web_vital", {
    metric_name: name,
    metric_value: Math.round(name === "CLS" ? value * 1000 : value),
    metric_id: id,
    metric_rating: grade,
    over_budget: overBudget,
  });
}

/**
 * Convenience initializer — import and call once in index.js.
 */
export function initPerformanceMonitoring(reportWebVitals) {
  if (typeof reportWebVitals === "function") {
    reportWebVitals(handleWebVital);
  }
}
